@use "../../../../globals/bcp";

:host {
  @include bcp.set-css-var(button, padding, bcp.size(12) bcp.size(0));
}
